// extracted by mini-css-extract-plugin
export default {"box":"GGVarImpact_box__FImu4","desc":"GGVarImpact_desc__p8VBP","ggVar":"GGVarImpact_ggVar__vfGuI","ggVarNone":"GGVarImpact_ggVarNone__bTviS"};